import { useContext } from 'react';
import { EmojiContext } from '@vision/ui/context';

export function useEmojiContext() {
  return useContext(EmojiContext);
}
